import { useEffect, useRef, useState } from "react";
import { QRCodeCanvasFactory } from "../misc/qrcodecanvas";
import { useMutation } from "@tanstack/react-query";
import { generateQR , axiosClient} from "../libs";
import { QRCodeImage, Spinner } from "../components";
import { useCreateCustomer,useCreateInvoice } from "../actions";
import { useWebSokect, useCountMinute, useValidateCustomer } from "../hooks";
import { BaseButton } from "../components/button";
import { CLOUDFLARE_SITEKEY, LIMIT_AMOUNT } from "../constants";

//#region
interface IUserForm{
  firstname? : string;
  lastname?: string;
  email?: string;
  address?: string;
  phone?: string;
  note?: string;
  amount?: string;
}

interface IUserValidateForm{
  firstname? : boolean;
  lastname?: boolean;
  email?: boolean;
  address? : boolean;
  amount?: boolean;
}

type bakongResponse = {
  message: string;
  timestamp: string;
  status: string;
  data: {
    responseCode: number
    responseMessage: string;
    errorCode: any;
    data: {
      hash: string;
      fromAccountId: string;
      toAccountId: string;
      currency: string;
      amount: string;
      description: string | null;
      createdDateMs:number;
      acknowledgedDateMs: number | null;
      trackingStatus: any;
      receiverBank: any;
      receiverBankAccount: any;
      instructionRef: any;
      externalRef: any;
    }
  } | null;
}
// const LIMIT_AMOUNT = parseFloat('0.1');
//#endregion
export default function UserRegister(){
  const arrValidateForm = ['email','firstname','lastname','address','phone','amount']
  const [values,setValues] = useState<IUserForm>()
  const [validateForm,setValidateForm] = useState<IUserValidateForm>({email: false, firstname: false, lastname: false, amount: false})
  const[amount,setAmount] = useState('')
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const[currency,setCurrency] = useState('USD')
  const[url,setUrl] = useState('')
  const[isValideEmail,setIsValidEmail] = useState(false)
  const customerActions = useCreateCustomer()
  const invocieActions = useCreateInvoice()
  const [idCustomer,setIdCustomer] = useState('')
  const [showFullName,setShowFullName] = useState('');
  const [isInvaliadeAmount,setIsinvalideAmount] = useState(false)
  const [isPhone,setIsphone] = useState(false);

  const[isLoading,setIsLoading] = useState(false)
  const[isTransactionSuccess,setIsTransactionSuccess]= useState(false)
  const[isSubmited,setIsSubmited]= useState(false)
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
  const[md5,setMd5] = useState('')
  const {socket} = useWebSokect();
  const {isCustomer} = useValidateCustomer();
  const [onHandleAmount,setOnHandleAmount] = useState<{amount:string,currency:string}>({amount: '0.00', currency: 'USD'})
  const {seconds, setSeconds} = useCountMinute();
  const formTurnStile = useRef<HTMLFormElement>(null)
  const [isTurnstile,setIsturnstile] = useState(true);

  useEffect(()=>{
    //@ts-expect-error [Callback Cloudflare]
    window.onloadTurnstileCallback = function () {
    //@ts-expect-error [Callback Cloudflare]
      turnstile.render("#gdt", {
        sitekey: CLOUDFLARE_SITEKEY,
        callback: function (token:string) {
          setIsturnstile(false);
          console.log(`Challenge Success ${token.split('.')[0]}`);
        },
      });
    };
  },[])
  

//#region  
  const QrCodeGenerator = async (mnt:number) =>{
    const info ={
      currency: currency || 'USD'
    }
  
    const result = generateQR({ 
      currencyUser : info.currency === 'USD' ? 'USD' : 'KHR', 
      amount: Number(mnt), 
      type: 'individual'
    })
    if (result.data) {
      localStorage.setItem('md5',result.data.md5)
      setMd5(result.data.md5)
      setSeconds(180)
      const qrCanvas = new QRCodeCanvasFactory(
        result.data.qr,
        info.currency,
        '53 Cloud',
        ''
      );

      const val = await qrCanvas.createQR();
      setUrl(val.qrcode)
    }
  }

  const { mutate } = useMutation({
    mutationKey: ['check-status-transaction-qr-code'],
    mutationFn: async (md5:string) => {
      return (await axiosClient.post('https://payment53-api-prod.53cloudsite.click/check-md5-dev',
        {
          md5: md5
        },
      )).data
    },
    onError: async (error) => console.log('ERROR BAKONG',error),
    onSuccess: async (res) => {
      const result = await res as bakongResponse;
      if(result.data && result?.data?.responseCode === 0){
        setIsTransactionSuccess(true);
        const inv = await invocieActions.mutateAsync({
            customer: idCustomer,
            status: "Paid",
            items: [
              {
                name: values?.note ?? 'Payment for Cloud Hosting',
                quantity: 1,
                price: Number(result.data.data.amount) || 0
              }
            ]
        })
        if(inv && inv.id){
          const payload = {
            invoice_id: inv.id,
            reference: result.data.data.hash || '',
            external_ref: result.data.data.externalRef || '',
            amount: result.data.data.amount || '0',
            status: 'paid',
            payment_method: 'BAKONG',
            attactment_url: inv.url || '',
            description: values?.note || 'Payment for Cloud Hosting',
            email: values?.email || 'example@gmail.com',
            first_name: values?.firstname || '',
            last_name: values?.lastname || ''
          }
          await axiosClient.post('https://payment53-api-prod.53cloudsite.click/create-transaction',payload)
          console.log('-----------------SUCCESS TRANSACTION--------------');
        }
        if (intervalId) {
          clearInterval(intervalId); // Stop checking on success
        }
      }else{
        setIsTransactionSuccess(false)
      }
    }
  })

  useEffect(() => {
    console.log('STREAMING...', isSubmited);
    if(!isSubmited) return;
    if (intervalId) {
      clearInterval(intervalId);
    }
    const id = setInterval(() => {
        if(md5 && !isTransactionSuccess && seconds !== 0){
        mutate(md5); // Call the mutation every 5 seconds
        }
        console.count(`will stop after 5 seconds `) //${md5} - ${isTransactionSuccess}
    }, 5000);
    setIntervalId(id);

  // Cleanup function to clear interval on component unmount
    return () => clearInterval(id);
  }, [md5, mutate]);
//#endregion
  const handleSubmitRecharg = async (e: React.FormEvent<HTMLFormElement>) =>{
    try{
     if(!values?.note){
      // setValues({note: 'Payment for Cloud Hosting'})
      setValues(prev => ({ ...prev, note: 'Payment for Cloud Hosting' }))
     }

      e.preventDefault()
      setIsSubmited(true) //Default = fasle 
      setIsLoading(true)
      setIsTransactionSuccess(false)
      arrValidateForm.forEach((field) => {
        //@ts-expect-error may not match with values in array
        if(!values?.[field]){
          setValidateForm((prev) => ({
            ...prev,
            [field]: false,
          }))
        }
      })
      //Start Create Customer 
      if(values?.email && !isValideEmail){
        const cusInfo = {
          billTo : {
            // company: "53 Cloud",
            //phone: "097321156",
            email: values.email,
            address: values.address,
            firstName: values.firstname,
            lastName: values.lastname,
            phone: values.phone,
          }
        }
        const cs = await customerActions.mutateAsync(cusInfo)
        if(cs && cs.id){
          setIdCustomer(cs.id)
        }
      }
      console.log(values)

      //End Create Customer
      setOnHandleAmount({amount: amount || '0.00',currency:currency});
      await QrCodeGenerator(Number(amount));
    }catch(error){
      console.log('Error')
    }finally{
      setIsLoading(false)
    }
  }
  const onFocusEmail = (e: React.ChangeEvent<HTMLInputElement>) =>{
    const { name, value } = e.target;
    
    if(name && value && isCustomer?.some((cs => cs?.billTo.email.toLowerCase() === value.toLocaleLowerCase()))){
      console.log('UNIQUE')
      const csm = isCustomer.filter((f) => f.billTo?.email.toLowerCase() === value.toLowerCase())[0]
      if(csm){
        setShowFullName(`${csm.billTo.firstName} ${csm.billTo.lastName}`)
        setIdCustomer(csm.internalId)
        setIsValidEmail(true);
        setValues({
          address: csm.billTo.address || '',
          firstname: csm.billTo.firstName || '',
          lastname: csm.billTo.lastName || '',
          phone: csm.billTo?.phone || '',
          email: csm.billTo.email
        })
      }
      setValidateForm({
        email: value ? false : true,
        firstname: csm.billTo.firstName ? false : true,
        lastname: csm.billTo.lastName ? false : true,
        address: csm.billTo.address ? false : true
      }) 
    }else if(name && !value){
      setValidateForm((prev) => ({
        ...prev,
        [name]: true,
      }));
    }else{
      const swapValues = {
        email: value.toLowerCase(),
        firstname: '',
        lastname: '',
        address: '',
        phone: '0'
      }
      setValues(swapValues);
      setIsValidEmail(false)
    }
  }
  const handleLossFocus = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const arrCheckListVal = ['0','0.0','0.00','0.01']

    if(name==='amount'){
      if(arrCheckListVal.includes(value) || parseFloat(value)<LIMIT_AMOUNT) setIsinvalideAmount(true)
      else setIsinvalideAmount(false)
    }
    if(value){
      setValidateForm((prev) => ({
        ...prev,
        [name]: false,
      }));
    }else if(!value){
      setValidateForm((prev) => ({
        ...prev,
        [name]: true,
      }));
    }
  }


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if(arrValidateForm.includes(name) && value){
      setValidateForm((prev) => ({
        ...prev,
        [name]: false,
      }));
    }else if(arrValidateForm.includes(name) && !value){
      setValidateForm((prev) => ({
        ...prev,
        [name]: true,
      }));
    }
    //const phoneFormat = formatPhoneNumber(value);
    setValues((prevValues) => ({
      ...prevValues,
      [name]: name === 'phone' ? formatPhoneNumber(value):value,
    }));
    if(name==="phone"){
      const phoneNumber = formatPhoneNumber(value);
      if(phoneNumber==="0" || phoneNumber.length<=1){
        setIsphone(false)
      }else if(phoneNumber.length>=9){
        setIsphone(false)
      }else{
        setIsphone(true)
      }
    }
  };

  const handleReload = () => {
    window.location.reload();
  };
  const formatPhoneNumber = (value: string) => {
    let cleaned = value.replace(/\D/g, "");

    // Ensure the number starts with '0' but not '00' eqeqw
    if (!cleaned.startsWith("0")) {
      cleaned = "0" + cleaned;
    } else if (cleaned.startsWith("00")) {
      cleaned = cleaned.slice(1);
    }
  
    // Trim to a maximum length of 10 digits (common for phone numbers)
    cleaned = cleaned.slice(0, 10);
  
    // Format according to XXX XXX XXXX pattern
    if (cleaned.length <= 3) {
      return cleaned;
    } else if (cleaned.length <= 6) {
      return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
    } else {
      return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
    }
  };
  const handleChangeAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;
  
    if (!/^\d*\.?\d{0,2}$/.test(val)) return;
  
    if (val.startsWith("0") && val.length > 1 && !val.startsWith("0.")) {
      val = val.replace(/^0+/, ""); // Remove leading zeros
    }
  
    if (val) {
      const arrCheckListVal = ['0', '0.0', '0.00'];
      const numericVal = parseFloat(val);
  
      setValidateForm((prev) => ({ ...prev, [e.target.name]: false }));
  
      if (arrCheckListVal.includes(val) || numericVal < LIMIT_AMOUNT) {
        setIsinvalideAmount(true);
      } else {
        setIsinvalideAmount(false);
      }
    } else {
      setValidateForm((prev) => ({ ...prev, [e.target.name]: true }));
    }
  
    setAmount(val); //Remove for production '0.01'
  };
  
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  
  return(
    <>
    {  (!isSubmited || seconds === 0) && !isTransactionSuccess && 
      <div className="w-full flex min-h-screen justify-center items-center py-5">
        <form 
          ref={formTurnStile}
          action="" 
          onSubmit={handleSubmitRecharg}
          method="POST" 
          className="md:mt-0 lg:mt-0 md:w-1/2 lg:w-[30%] w-full space-y-6 bg-white rounded-lg p-6  text-left">
          <div className="w-full flex justify-center items-center">
            <img fetchPriority="high" src="./logo53cloud.jpeg" width={180} alt="logo" /> {/** 220 180 */}
          </div>
          <div>
            <label htmlFor="email" className="block uppercase text-smaller font-medium text-[#28386a]">
              Email <sup className="text-red-400 m-0 font-bold text-[11px]">*</sup>
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                required
                placeholder="example@gmail.com"
                autoComplete="email"
                onChange={handleChange}
                onBlur={onFocusEmail}
                className="block w-full rounded-md bg-white px-3 py-2.5 md:py-1.5 lg:py-1.5 xl:py-1.5 text-base text-[#28386a] outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-[#28386a] sm:text-sm/6"
              />
               {validateForm.email && <p className="text-red-500 text-xs italic">Please fill out this field.</p>}
               {isValideEmail && !validateForm.email && <p className="text-[#28386a] text-xs/8 italic">Welcome back <strong>{showFullName}</strong> </p>}
            </div>
          </div>
          <div className="w-full grid grid-cols-2 gap-4">
            <div>
                <label htmlFor="password" className="block uppercase text-smaller font-medium text-[#28386a]">
                  first name <sup className="text-red-400 m-0 font-bold text-[11px]">*</sup>
                </label>
              <div className="mt-2">
                <input
                  id="firstname"
                  name="firstname"
                  type="text"
                  placeholder="First name"
                  onBlur={handleLossFocus}
                  value={values?.firstname}
                  required 
                  disabled={isValideEmail}
                  onChange={handleChange}
                  autoComplete="current-password"
                  className="block w-full rounded-md bg-white px-3 py-2.5 md:py-1.5 lg:py-1.5 xl:py-1.5 text-base text-[#28386a] outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-[#28386a] sm:text-sm/6"
                />
                {validateForm.firstname && <p className="text-red-500 text-xs italic">Please fill out this field.</p>}
              </div>
            </div>
            <div>
                <label htmlFor="password" className="block uppercase text-smaller font-medium text-[#28386a]">
                Last name <sup className="text-red-400 m-0 font-bold text-[11px]">*</sup>
                </label>
              <div className="mt-2">
                <input
                  id="lastname"
                  name="lastname"
                  type="text"
                  placeholder="Last name"
                  required
                  onBlur={handleLossFocus}
                  value={values?.lastname}
                  disabled={isValideEmail}
                  onChange={handleChange}
                  className="block w-full rounded-md bg-white px-3 py-2.5 md:py-1.5 lg:py-1.5 xl:py-1.5 text-base text-[#28386a] outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-[#28386a] sm:text-sm/6"
                />
                {validateForm.lastname && <p className="text-red-500 text-xs italic">Please fill out this field.</p>}
              </div>
            </div>
          </div>
          <div>
              <label htmlFor="phone" className="block uppercase text-smaller font-medium text-[#28386a]">
              Phone
              </label>
            <div className="mt-2">
              <input
                id="phone"
                name="phone"
                type="text"
                placeholder="Phone number"
                value={values?.phone}
                disabled={isValideEmail}
                maxLength={14}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-2.5 md:py-1.5 lg:py-1.5 xl:py-1.5 text-base text-[#28386a] outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-[#28386a] sm:text-sm/6"
              />
              {isPhone && <p className="text-red-500 text-xs italic">Phone number at least 9 length.</p>}
            </div>
          </div>

          <div>
              <label htmlFor="amount" className="block uppercase text-smaller font-medium text-[#28386a]">
              Amount <sup className="text-red-400 m-0 font-bold text-[11px]">*</sup>
              </label>
            <div className="mt-2">
              <input
                id="amount"
                name="amount"
                type="text"
                placeholder="Amount"
                value={amount}
                required
                onFocus={handleLossFocus}
                min={LIMIT_AMOUNT}
                step={LIMIT_AMOUNT}
                onChange={handleChangeAmount}
                className="block w-full rounded-md bg-white px-3 py-2.5 md:py-1.5 lg:py-1.5 xl:py-1.5 text-base text-[#28386a] outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-[#28386a] sm:text-sm/6"
              />
              {validateForm.amount && <p className="text-red-500 text-xs italic">Please fill out this field.</p>}
              {isInvaliadeAmount && !validateForm.amount && <p className="text-red-500 text-xs italic">Amount must above or equal {LIMIT_AMOUNT} </p>}

            </div>
          </div>
          <div>
              <label htmlFor="address" className="block uppercase text-smaller font-medium text-[#28386a]">
              Address <sup className="text-red-400 m-0 font-bold text-[11px]">*</sup>
              </label> 
            <div className="mt-2">
              <input
              type="text"
              id="address"
              name="address"
              placeholder="Phnom Penh, Cambodia"
              onBlur={handleLossFocus}
              onChange={handleChange}
              required
              value={values?.address}
              disabled={isValideEmail}
              className="block w-full rounded-md bg-white px-3 py-2.5 md:py-1.5 lg:py-1.5 xl:py-1.5 text-base text-[#28386a] outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-[#28386a] sm:text-sm/6"
              />
              {validateForm.address && <p className="text-red-500 text-xs italic">Please fill out this field.</p>}
            </div>
          </div>
          <div>
              <label htmlFor="note" className="block uppercase text-smaller font-medium text-[#28386a]">
                Invoice Note
              </label>
            <div className="mt-2">
              <textarea
              id="note"
              name="note"
              placeholder="Payment for Cloud Hosting"
              onChange={handleChange}
                rows={3}
                className="block w-full rounded-md bg-white px-3 py-2.5 md:py-1.5 lg:py-1.5 xl:py-1.5 text-base text-[#28386a] outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-[#28386a] sm:text-sm/6"
              ></textarea>
            </div>
          </div>

          <div className="w-full flex gap-x-3 justify-end">
            <BaseButton title="Continue to payment" type="submit" isInvaliadeAmount={isInvaliadeAmount} isTurnstile={isTurnstile&&parseFloat(amount)>=LIMIT_AMOUNT} validPhone={isPhone&&parseFloat(amount)>=LIMIT_AMOUNT}/>
          </div>
          <div className="w-full font-medium my-3" id="gdt">
              <div className="cf-turnstile" data-sitekey={`${CLOUDFLARE_SITEKEY}`}></div>
          </div>
        </form>
      </div>
    }
    {seconds !==0 && !isTransactionSuccess && 
      <div className={`w-full justify-center min-h-screen flex items-center py-4 `}>
        <div className="bg-white lg:w-[30%] px-4 rounded-md">
          {
            !isLoading && !isTransactionSuccess && seconds!== 0 && url && 
            <BaseButton
              className=" mt-4 gap-x-3"
              title="Back home" 
              type="submit" 
              onClick={handleReload}
              >
            </BaseButton>
          }
          <div className='mt-0'>
              { seconds !==0 && !isTransactionSuccess &&
              <div>
                <Spinner width='30' height='30' />
                <strong className='mt-0 font-extrabold text-[40px] text-red-600'> 
                    0{minutes} : {remainingSeconds.toString().length===1 ? '0':''}{remainingSeconds} 
                  </strong>
              </div>
              }
          </div>

          <div className='p-0 flex items-center justify-center'> {/** p-4 */}
              {
                isLoading && <Spinner width='38' height='38' />
              }
              {
                !isLoading && !isTransactionSuccess && seconds!== 0 && url && 
                <>
                    <div className="w-full grid grid-cols-1 gap-y-6">
                      <div className="flex justify-center">
                        <QRCodeImage amount={onHandleAmount.amount} currency={onHandleAmount.currency} url={url}/>
                      </div>
                      <h3 className="uppercase font-bold text-[#28386a]">support </h3>
                      <div className="flex justify-center mt-0">
                        <img fetchPriority="high" src="./KHQR-53Pay.png" width={1920} height={1080} className="rounded-lg h-16 object-contain" alt="payment-support" />
                      </div>
                    </div>
                </>
              }
          </div>
        </div>
      </div>
    }

    { md5 && isTransactionSuccess  &&  
      <div className={`w-full h-screen flex justify-center items-center `}>
        <div className="bg-white w-[600px] rounded-md py-4">
          <div className='p-4 flex items-center justify-center'>
              {
                isLoading && <Spinner width='38' height='38' />
              }
              <div className="w-full grid gap-y-12">
                  <div  
                    className='md:px-40 lg:px-40 px-24  py-0 rounded-3xl gap-x-2 font-bold text-center items-center text-[18px] md:mx-0 lg:mx-0 mx-auto '>
                    <div className='w-full flex justify-center mb-3'>
                      <img fetchPriority="high" width={60} src="./done.gif" alt="aa" />
                    </div>
                    <h2 className='w-full  text-[#28386a] lg:text-2xl/10 md:text-lg text-lg text-center'>Payment confirmed</h2>

                    <h2 className='w-full text-[#28386a] lg:text-xl/10 text-sm text-center'>Thank you</h2>
                    <p className='w-full text-[#28386a] text-sm/10 text-center hidden'>Transaction successfully</p>

                  </div>
                  <div className="flex justify-center">
                      <a 
                        className="flex uppercase justify-center rounded-[16px]  text-sm/6 font-semibold text-white shadow-sm bg-[#28386a] py-2 px-6 items-center hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" 
                        href={invocieActions.data?.url} 
                        target="_blank" rel="noreferrer">
                          View Invoice
                      </a>
                  </div>
              </div>
          </div>
        </div>
      </div>
      }
    </>
  )
}
